import { Injectable } from '@angular/core';
import { Event, NavigationStart, Router, Scroll } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { filter, tap } from 'rxjs/operators';


/**
 * @description
 *
 * A service that keeps the scroll position of the current page.
 *
 */
@Injectable()
export class ScrollPositionHelperService {

    position: [number, number];

    constructor(
        private router: Router,
        private viewportScroller: ViewportScroller) {
        this.position = [0, 0];
    }

    getObservable() {
        return this.router.events.pipe(
            tap(e => {
                if (e instanceof NavigationStart) {
                    const [a, b] = this.viewportScroller.getScrollPosition();
                    this.position = [a, b];
                }
            }),
            filter((e: Event): e is Scroll => e instanceof Scroll),
            tap(e => {
                if (!e.position && !e.anchor) {
                    this.viewportScroller.scrollToPosition(this.position);
                }
            })
        );
    }
}
